import loadable from '@loadable/component';

export const CmsPagePageLoadable = loadable(() => import('./CmsPagePage'), {
  resolveComponent: (module) => module.CmsPagePage,
});
